import { CONTENT_GROUP_ACTION } from "../constants";
import { NEW_STAGE_MODAL_ACTIONS } from "../constants/stage.constants";

const initialState = {
    isNewStageModalOpen: false,
    boundary: {} // Position of Reference Element
};

export const new_stage_popup = (state = initialState, action) => {
  switch (action.type) {
    case NEW_STAGE_MODAL_ACTIONS.OPEN_NEW_STAGE_MODAL:
      return {
        ...state,
        isNewStageModalOpen: true,
        boundary: action.payload,
      };
    case NEW_STAGE_MODAL_ACTIONS.CLOSE_NEW_STAGE_MODAL:
      return {
        ...state,
        isNewStageModalOpen: false,
        boundary: {},
      };
    default:
      return state;
  }
};